"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionBar = exports.useStyles = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const detail_actionbar_button_1 = require("../../composite/detail/detail-actionbar-button");
const dictionary_evidence_1 = require("../../composite/evidence/dictionary-evidence/dictionary-evidence");
const test_hook_1 = require("./actions/test-hook");
exports.useStyles = (0, makeStyles_1.default)(() => ({
    toolbarIndentLeft: {
        marginLeft: 10,
    },
}));
function ActionBar() {
    const intl = (0, react_intl_1.useIntl)();
    const { handleTestNotification, showTestNotificationButton } = (0, test_hook_1.useTestNotification)();
    const DictionaryActionbar = (0, dictionary_evidence_1.dictionaryActionbarFactory)({});
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DictionaryActionbar, null),
        showTestNotificationButton && (react_1.default.createElement(detail_actionbar_button_1.PrimaryDetailActionbarButton, { label: intl.formatMessage({
                id: 'EAS_NOTIFICATION_TEMPLATES_ACTIONBAR_BTN_TEST',
                defaultMessage: 'Ukázka',
            }), onClick: handleTestNotification }))));
}
exports.ActionBar = ActionBar;
//# sourceMappingURL=notification-template-actionbar.js.map